import AppRatingAPI from 'api/app-rating';

export const APP_RATING_LOAD_DATA = 'APP_RATING_LOAD_DATA';

export const appRatingLoadData = () => {
    return (dispatch, getState) => {
        const {
            appRating: {data, isPending},
        } = getState();

        if (!isPending && !data) {
            dispatch({
                type: APP_RATING_LOAD_DATA,
                payload: AppRatingAPI.get(),
            });
        }
    };
};
